// extracted by mini-css-extract-plugin
var _1 = "RecipientAudienceRadioFields-moduleradioGroup__il2nT RadioGroup-moduleRadioGroup__JpFJJ";
export { _1 as "radioGroup" }
